"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPlayerForVideo = createPlayerForVideo;
exports.fetchVideoFileByPlayerId = fetchVideoFileByPlayerId;
exports.softDeleteHubLVideoPlayer = softDeleteHubLVideoPlayer;
exports.fetchEmbedCode = fetchEmbedCode;
exports.fetchUserAccessToExternalEmbedsState = fetchUserAccessToExternalEmbedsState;

var _immutable = _interopRequireDefault(require("immutable"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var URI = 'filemanager/api/v3/players';

function createPlayerForVideo(fileId) {
  var httpClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _apiClient.default;
  return httpClient.post(URI, {
    data: {
      file_id: fileId,
      try_reuse: true
    }
  }).then(_immutable.default.fromJS);
}

function fetchVideoFileByPlayerId(playerId) {
  var httpClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _apiClient.default;
  return httpClient.get(URI + "/" + playerId + "/videos/file-metadata").then(_immutable.default.fromJS);
}

function softDeleteHubLVideoPlayer(playerId) {
  var httpClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _apiClient.default;
  return httpClient.delete(URI + "/" + playerId);
}

function fetchEmbedCode(playerId, provider) {
  var playerAttributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var httpClient = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _apiClient.default;
  return httpClient.post(URI + "/" + playerId + "/embed-codes", {
    data: {
      player_id: playerId,
      provider: provider,
      usage: 'EXTERNAL_EMBEDDED',
      player_attributes: playerAttributes
    }
  }).then(_immutable.default.fromJS);
}

function fetchUserAccessToExternalEmbedsState() {
  var httpClient = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _apiClient.default;
  return httpClient.get(URI + "/external-embed-access").then(_immutable.default.fromJS);
}